import { render } from "./ButtonClearDate.vue?vue&type=template&id=20be00f8"
import script from "./ButtonClearDate.vue?vue&type=script&lang=js"
export * from "./ButtonClearDate.vue?vue&type=script&lang=js"

import "./ButtonClearDate.vue?vue&type=style&index=0&id=20be00f8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__